<template>
    <div>
        <content-view v-show="$utils.renderWhen(this,'channel')">
        <!-- 渠道管理 -->
        <div slot="header">
            <a-form :form="filterForm" layout="inline" class="store-one-form">
            <a-form-item label="渠道标识">
                <a-input placeholder="请输入" v-decorator="['mark']" @pressEnter="search"></a-input>
            </a-form-item>
            <a-form-item label="渠道名称">
                <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search"></a-input>
            </a-form-item>
                <!-- <a-form-item label="状态" >
                    <a-select v-decorator="['isEnable']" placeholder="请选择" allowClear >
                        <a-select-option :value="1">使用中</a-select-option>
                        <a-select-option :value="0">已冻结</a-select-option>
                    </a-select>
                </a-form-item> -->
            <a-form-item class="wrap-header-button">
                <a-button type="primary" @click="search(false)">筛选</a-button>
                <a-button @click="handleReset()">重置</a-button>
            </a-form-item>
            </a-form>
        </div>
        <div>
            <a-card
            :bordered="false"
            :tabList="tabListNoTitle"
            :activeTabKey="noTitleKey"
            @tabChange="key => onTabChange(key)"
            >
                <div slot="tabBarExtraContent" class="mb16">
                    <a-button v-if="getBtnByAuth('addChannel')" type="primary" @click="openMondal()">新增渠道</a-button>
                    <a-button v-if="getBtnByAuth('addChannel')" type="primary" @click="toggleFreeze">批量{{noTitleKey === '1' ? '冻结' : '解冻'}}</a-button>
                </div>
                <a-table
                bordered
                :dataSource="warehouse"
                :columns="columns"
                :pagination="pagination"
                :rowKey="record => record.id"
                :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
                @change="changePage"
                >
                    <!-- <span slot="isEnable" slot-scope="isEnable">{{isEnable ? '使用中' : '已冻结'}}</span> -->
                    <span slot="remarks" slot-scope="remarks">{{remarks || '-'}}</span>
                    <span slot="recordNum" slot-scope="recordNum">{{recordNum || '-'}}</span>
                    <span slot="action" slot-scope="a,row">
                        <a class="text-primary" @click="lookEr(row.qrcodeUrl)">查看下载小程序码</a>
                        <a-divider type="vertical"/>
                        <span v-if="getBtnByAuth('visitDetail')">
                            <a class="text-primary" @click="toWareHouse(row)">访问详情</a>
                            <a-divider type="vertical"/>
                        </span>
                        <a-popconfirm
                            v-if="getBtnByAuth('channelState')"
                            :title="'确定将该渠道'+(row.isEnable == '1' ? '冻结' : '解冻')+'吗?'"
                            @confirm="channelState(row.id, row.isEnable)"
                            >
                            <a class="text-primary">{{row.isEnable == '1' ? '冻结' : '解冻'}}</a>
                        </a-popconfirm>
                    </span>
                </a-table>
            </a-card>
            <!-- 添加和详情弹窗 -->
            <a-modal
            title="新增渠道"
            :visible="newStorageVisible"
            centered
            @ok="addWarehouse"
            @cancel="handleCancel"
            >
                <a-form :form="form">
                    <a-form-item label="渠道标识" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                        <a-input
                            placeholder="请输入英文字母"
                            v-decorator="['mark', {rules: [{ required: true, message: '请输入渠道标识'}, {message: '请输入英文字母', pattern:/[a-zA-Z]+$/g}]}]"
                        />
                    </a-form-item>
                    <a-form-item label="渠道名称" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                        <a-input
                            placeholder="请输入"
                            v-decorator="['name', {rules: [{ required: true, message: '请输入渠道名称' }]}]"
                        />
                    </a-form-item>
                    <a-form-item label="绑定小程序入口/URL" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" required>
                        <a-input
                            placeholder="pages/index/index"
                            v-decorator="['entranceUrl', {rules: [{ required: false, message: '请输入绑定小程序入口/URL' }]}]"
                        />
                    </a-form-item>
                    <a-form-item label="备注" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                        <a-textarea
                            :rows="3"
                            placeholder="请输入"
                            v-decorator="['remarks', {rules: [{ required: true, message: '请输入备注' }]}]"
                        />
                    </a-form-item>
                </a-form>
            </a-modal>
            <a-modal
                title="查看下载小程序码"
                :visible="erVisible"
                okText="下载"
                @ok="downloadEr(ErSrc,'小程序渠道码')"
                @cancel="erVisible = false"
            >
                <div class="text-center">
                    <img :src="ErSrc" alt="图片获取失败">
                </div>
            </a-modal>
        </div>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    export default {
        name: 'channel',
        components: {},
        props: {},
        data() {
            const tabListNoTitle = [
                {
                    key: '1',
                    tab: '生效中',
                    columnLine: columns
                },
                {
                    key: '0',
                    tab: '已冻结',
                    columnLine: columns
                },
            ]
            const columns = [
                {
                    title: '渠道标识',
                    dataIndex: 'mark',
                },
                {
                    title: '渠道名称',
                    dataIndex: 'name'
                },
                {
                    title: 'URL',
                    dataIndex: 'entranceUrl'
                },
                {
                    title: '备注',
                    dataIndex: 'remarks',
                    scopedSlots: { customRender: "remarks" }
                },
                {
                    title: '用户访问量',
                    dataIndex: 'recordNum',
                    scopedSlots: { customRender: "recordNum" }
                },
                // {
                //     title: "状态",
                //     dataIndex: "isEnable",
                //     scopedSlots: { customRender: "isEnable" }
                // },
                {
                    title: '操作',
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' }
                }
            ];
            return {
                columns,
                warehouse: [],
                tabListNoTitle,
                noTitleKey: '1',
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                newStorageVisible: false, //添加仓库
                filterForm: this.$form.createForm(this), //筛选表单
                form: this.$form.createForm(this), //添加和编辑表单
                id: '',
                ErSrc: '',
                erVisible: false,
                selectedRowKeys: [],
            };
        },
        beforeCreate() {},
        watch: {},
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            // 重置筛选
            handleReset() {
                this.filterForm.resetFields();
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            onTabChange(noTitleKey) {
                this.noTitleKey = noTitleKey
                this.pagination.current = 1;
                setTimeout(() => {
                    this.getList();
                }, 400);
            },
            // 多选选中
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            toggleFreeze() {
                if(this.selectedRowKeys.length === 0) {
                    this.$message.warning('请选择要'+(this.noTitleKey === '1' ? '冻结' : '解冻')+'的渠道！')
                }else {
                    this.$api.totalPlatform.toggleFreeze({ body: {
                        idList: this.selectedRowKeys,
                        isEnable: this.noTitleKey === '1' ? 0 : 1
                    } }).then(res => {
                        this.$message.success('操作成功');
                        this.getList();
                        this.selectedRowKeys = [];
                    });
                }
            },
            //获取列表
            getList() {
                this.filterForm.validateFields((err, values) => {
                    if (err) return;
                    values.isEnable = Number(this.noTitleKey);
                    this.$api.totalPlatform.channelList({ body: {
                        ...values,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize
                    } }).then(res => {
                        this.warehouse = res.list;
                        this.pagination.total = res.total;
                    });
                })
            },
            // 查看二维码
            lookEr(qrcodeUrl) {
                this.erVisible = true
                this.ErSrc = qrcodeUrl;
            },
            // 下载二维码
            downloadEr(imgsrc, name) {//下载图片地址和图片名
                this.$api.common.downloadImage({
                    query: {
                        url: imgsrc
                    }
                }, {
                    responseType: 'blob'
                }).then(res => {
                    let a = document.createElement("a");
                    let event = new MouseEvent("click"); // 创建一个单击事件
                    let blob = new Blob([res.data], {
                        type: "image/png"
                    });
                    this.downloadUrl = window.URL.createObjectURL(blob);
                    a.setAttribute("href", this.downloadUrl);
                    a.setAttribute("download", `${name}.png`);
                    a.dispatchEvent(event); // 触发a的单击事件
                });
            },
            // 打开弹窗
            openMondal(row = null) {
                this.newStorageVisible = true;
                if(row) {
                    this.toEditerRow(row)
                    this.id = row.id;
                }else {
                    this.id = undefined;
                }
            },
            // 添加编辑渠道
            addWarehouse() {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        values.entranceUrl = values.entranceUrl || 'pages/index/index';
                        values.shopId = this.shopId;
                        values.id = this.id;
                        this.$api.totalPlatform.channelAdd({
                            body: values
                        }).then(res => {
                            this.$message.success('操作成功');
                            this.getList();
                            this.handleCancel();
                        });
                    }
                });
            },
            //编辑回填
            toEditerRow(row) {
                let value = {
                    mark: row.mark,
                    name: row.name,
                    entranceUrl: row.entranceUrl,
                    remarks: row.remarks
                }
                this.$nextTick(() => {
                    this.form.setFieldsValue(value);
                });
            },
            // 关闭弹框
            handleCancel() {
                this.newStorageVisible = false;
                this.form.resetFields();
            },
            //跳转到仓库仓储
            toWareHouse(row) {
                this.$router.push({ name: 'visitDetail',query: { channelMark: row.mark } });
            },

            // 修改状态
            channelState(id, isEnable) {
                this.$api.totalPlatform[isEnable ? 'channelFreeze' : 'channelUnfreeze']({
                    params: {
                        id
                    }
                }).then(res => {
                    this.$message.success('操作成功',2);
                    this.getList();
                })
            },
        },
        created() {},
        mounted() {
            this.getList();
        },
        watch: {
            '$route'(val) {
                val.name == 'storageIndex' && this.getList();
            },
        }
    };
</script>
<style lang="scss">
    .wrap-container-in {
        background-color: #fff;
        padding: 24px 32px;
        border-radius: 2px;
    }
    .delectVisible {
        .delect_tips {
            text-align: center;
            height: 50px;
            font-weight: bold;
            font-size: 20px;
        }
        .delect_btn {
            display: flex;
            justify-content: space-around;
        }
    }
</style>
